import { useDocumentMeta } from '@/hooks'
import { AdminDashboard, AdminLogin, useAdminSession } from '@/features/admin'

/**
 * The admin surface: sign-in, then the content editor.
 *
 * Route-level auth only — the API is the real boundary. Every write is
 * rejected without a valid bearer token, so reaching this page proves
 * nothing on its own.
 */
export const AdminPage = () => {
  const session = useAdminSession()
  useDocumentMeta({ title: 'Admin' })

  if (session.isChecking) return null

  if (!session.token) {
    return <AdminLogin onSignIn={session.signIn} />
  }

  return (
    <AdminDashboard
      token={session.token}
      email={session.email}
      onSignOut={session.signOut}
    />
  )
}
